import { render } from "./AddCartWithCarousel.vue?vue&type=template&id=1612dedc&scoped=true"
import script from "./AddCartWithCarousel.vue?vue&type=script&lang=js"
export * from "./AddCartWithCarousel.vue?vue&type=script&lang=js"

import "./AddCartWithCarousel.vue?vue&type=style&index=0&id=1612dedc&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1612dedc"]])

export default __exports__